import { applyMiddleware, createStore, combineReducers } from 'redux'
import {createLogger} from 'redux-logger'

import estateReducer from './estateReducer'
import filtersReducer from './filtersReducer'

let store;
if (process.env.NODE_ENV === 'development') {
    const middleWare = applyMiddleware(createLogger());
    store = createStore(combineReducers({estates: estateReducer, filters: filtersReducer}), middleWare);
} else {
    store = createStore(combineReducers({estates: estateReducer, filters: filtersReducer}))
}
export default store;
